import Footer from 'components/home/Footer';
import {Col, Grid} from "../../mrf/view/Grid";
import AdminCard from "./AdminCard";
import IFAuth from "../../mrf/view/IFAuth";
import MctaCard from 'components/home/MctaCard';

export default function Dashboard() {
    return (
        <>
            <div className='p-4 overflow-y-scroll h-footer-container'>
                <Grid gap={6}>
                    <IFAuth roleCodes={['admin']}>
                        <Col size={3} md={4}>
                            <AdminCard/>
                        </Col>
                    </IFAuth>
                    <Col size={3} md={4}>
                        <MctaCard/>
                    </Col>
                </Grid>
            </div>
            <Footer/>
        </>
    );
}